import { createMemoStyles } from '@wds/utils';

import { MD_MEDIA_QUERY } from '~shared/media-query';
import { PricingAppTheme } from '~app/styles/pricing/types';

export default createMemoStyles(({ spacing, pricingPalette }: PricingAppTheme) => ({
  Highlight: {
    backgroundColor: pricingPalette.colors.canvas,
  },
  Features: {
    listStyle: 'none',
    fontSize: 13,
    lineHeight: 1.2,
    color: pricingPalette.colors.charcoal,
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    margin: [20, 'auto', 30],
    width: '100%',
    [MD_MEDIA_QUERY]: {
      margin: [20, 0, 30],
    },
  },
  FeatureItem: {
    position: 'relative',
    padding: [6, spacing[6], 6],
    display: 'flex',
    alignItems: 'center',
    wordBreak: 'break-word',
    '&:before': {
      content: '"•"',
      display: 'inline-block',
      paddingRight: 10,
      color: pricingPalette.colors.stone,
      fontSize: 20,
      flex: 1,
      alignSelf: 'flex-start',
      lineHeight: 0.9,
    },
    [MD_MEDIA_QUERY]: {
      padding: `6px ${spacing[7]}px 6px ${spacing[6]}px`,
      '&:hover': {
        extend: 'Highlight',
        transition: '0.2s ease',
      },
    },
  },
  FeatureSummary: {
    lineHeight: 1.6,
    position: 'relative',
    width: '100%',
    paddingLeft: 10,
    marginLeft: -10,
    [MD_MEDIA_QUERY]: {
      '&:hover': {
        '& $TooltipContainer': {
          display: 'inline-block',
        },
      },
    },
  },
  TooltipContainer: {
    display: 'none',
  },
}));
